import { graphqlDynamic } from "react-apollo-dynamic-query"
import gql from "graphql-tag"
import LineGraphCard from "."
import moment from "moment"
import { connect } from "react-redux"
import {
  GRAPHQL_DATE_FORMAT,
  NR_MIN_OPPORTUNITIES,
  BSR_MIN_OPPORTUNITIES,
} from "../../helpers/sharedConstants"
import { complianceNumberConverter } from "@swipesense/compliance-helpers"
import PropTypes from "prop-types"

const OVERALL = {
  key: "bothShifts",
  legendLabel: "Overall",
  hoverLabel: "Overall",
}

const FIRST_SHIFT = {
  key: "first",
  legendLabel: "1st Shift Change",
  hoverLabel: "1st Shift Change",
}

const SECOND_SHIFT = {
  key: "second",
  legendLabel: "2nd Shift Change",
  hoverLabel: "2nd Shift Change",
}

// const THIRD_SHIFT = {
//   key: "third",
//   legendLabel: "3rd Shift Change",
//   hoverLabel: "3rd Shift Change",
// }

// const SHIFT_MAPPING = {
//   department: [OVERALL, FIRST_SHIFT, SECOND_SHIFT, THIRD_SHIFT],
//   unit: [OVERALL, FIRST_SHIFT, SECOND_SHIFT, THIRD_SHIFT],
//   facility: [OVERALL, FIRST_SHIFT, SECOND_SHIFT, THIRD_SHIFT],
// }

const SHIFT_MAPPING_BSR = {
  department: [OVERALL, FIRST_SHIFT, SECOND_SHIFT],
  unit: [OVERALL, FIRST_SHIFT, SECOND_SHIFT],
  facility: [OVERALL, FIRST_SHIFT, SECOND_SHIFT],
}

const SHIFT_MAPPING_NR = {
  department: [OVERALL],
  unit: [OVERALL],
  facility: [OVERALL],
}

const generateQuery = ({ entityType, startAt, endAt, bsrCompliance }) => {
  const daysShown = endAt.diff(startAt, "days") + 1

  let period
  if (daysShown <= 12) {
    period = "days"
  } else if (daysShown <= 59) {
    period = "weeks"
  } else {
    period = "months"
  }

  // if (bsr) {//return query}
  // if (rounding {//return other query})

  return gql`

    query LineGraphCard(
        $entityId: ID!
        $startAt: String!
        $endAt: String!
    ) {
      entity: ${entityType}(id: $entityId) {
        id
        compliance: ${
          bsrCompliance ? "bsrCompliance" : "roundingCompliance"
        }(startAt: $startAt, endAt: $endAt) {
          timeslices {
            timeslicesArray: ${period} {
              startsAt
              endsAt
              bothShifts: aggregates {
                compliancePercentage
                ${
                  bsrCompliance
                    ? "compliantOpportunityCount"
                    : "compliantRoundCount"
                }
                ${bsrCompliance ? "opportunityCount" : "roundCount"}
              }
              ${
                bsrCompliance
                  ? `
                first: aggregates(shiftNumber: 1) {
                opportunityCount
                compliantOpportunityCount
                compliancePercentage
              }
              second: aggregates(shiftNumber: 2) {
                opportunityCount
                compliantOpportunityCount
                compliancePercentage
              }
              third: aggregates(shiftNumber: 3) {
                opportunityCount
                compliantOpportunityCount
                compliancePercentage
              }`
                  : ""
              }
            }
          }
        }
      }
    }
  `
}

const timesliceToData = (aggregates, min_opportunities, bsrCompliance) => {
  const count = bsrCompliance
    ? aggregates.opportunityCount
    : aggregates.roundCount

  return {
    compliance: complianceNumberConverter(
      aggregates.compliancePercentage,
      count,
      min_opportunities
    ),
    opportunities: count,
  }
}

const LineGraphCardWithApollo = graphqlDynamic(generateQuery, {
  options: ({ entityId, startAt, endAt }) => ({
    variables: {
      entityId,
      startAt: startAt.format(GRAPHQL_DATE_FORMAT),
      endAt: endAt.format(GRAPHQL_DATE_FORMAT),
    },
  }),
  props: ({
    data: { error, loading, entity },
    ownProps: { bsrCompliance, entityType },
  }) => {
    if (error) {
      throw error
    }
    if (!loading) {
      if (!entity) {
        throw Error("404")
      }
      const min_opportunities = bsrCompliance
        ? BSR_MIN_OPPORTUNITIES
        : NR_MIN_OPPORTUNITIES
      const shiftMapping = bsrCompliance
        ? SHIFT_MAPPING_BSR[entityType]
        : SHIFT_MAPPING_NR[entityType]
      return {
        loading,
        timeRanges: entity.compliance.timeslices.timeslicesArray.map(ts => [
          ts.startsAt,
          ts.endsAt,
        ]),
        groups: shiftMapping.map(group => ({
          ...group,
          data: entity.compliance.timeslices.timeslicesArray.map(timeslice =>
            timesliceToData(
              timeslice[group.key],
              min_opportunities,
              bsrCompliance
            )
          ),
        })),
      }
    } else {
      return {
        loading,
      }
    }
  },
})(LineGraphCard)

const LineGraphCardWithData = connect(
  ({
    dateRange: { startDate, endDate },
    bsrCompliance: { bsrCompliance },
  }) => ({
    startAt: moment(startDate),
    endAt: moment(endDate),
    bsrCompliance: bsrCompliance,
  })
)(LineGraphCardWithApollo)

LineGraphCardWithData.propTypes = {
  entityId: PropTypes.string.isRequired,
  entityType: PropTypes.oneOf(["facility", "department", "unit"]).isRequired,
}

export default LineGraphCardWithData
